import { Component, Injector, Input } from '@angular/core';
import { appearance } from 'src/app/config/appearance';
import { BaseView } from '../base-view';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent extends BaseView {

  @Input() maxWidth: number;
  @Input() padding: number = 20;
  @Input() margin: number = 0;

  constructor(protected _injector: Injector) { 
    super(_injector)
  }
}
